// Should stay in sync with resourcePermissionsType.mjs

export default {
  ATL: 1,
  ATM: 2,
  SPONSOR_COORDINATOR: 3,
  FDA_ADMIN_REVIEWER: 4,
  VIP_PARTNER: 5,
  VIP_FREE_LICENSE: 6
};
